import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/business",
    name: "business",
    redirect: {
        name: "business",
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: "/business/msgLog",
            name: "msgLog",
            meta: {
                ...meta,
                title: "短信记录",
            },
            component: () => import("@/pages/business/msgLog.vue"),
        },
        {
            path: "/business/msgTemplate",
            name: "msgTemplate",
            meta: {
                ...meta,
                title: "短信模板",
            },
            component: () => import("@/pages/business/msgTemplate.vue"),
        },
        {
            path: "/business/speedDial",
            name: "speedDial",
            meta: {
                ...meta,
                title: "快捷拨号",
            },
            component: () => import("@/pages/business/SpeedDial.vue"),
        },
        {
            path: "/business/sentence",
            name: "sentence",
            meta: {
                ...meta,
                title: "常用语",
            },
            component: () => import("@/pages/business/Sentence.vue"),
        },
        {
            path: "/business/duration",
            name: "duration",
            meta: {
                ...meta,
                title: "时长预警",
            },
            component: () => import("@/pages/business/Duration.vue"),
        },
        {
            path: "/business/special",
            name: "special",
            meta: {
                ...meta,
                title: "特殊人员",
            },
            component: () => import("@/pages/business/Special.vue"),
        },
        {
            path: "/business/attribution",
            name: "attribution",
            meta: {
                ...meta,
                title: "归口",
            },
            component: () => import("@/pages/business/Attribution.vue"),
        },
        {
            path: "/business/record",
            name: "record",
            meta: {
                ...meta,
                title: "录音",
            },
            component: () => import("@/pages/business/Record.vue"),
        },
        {
            path: "/business/callCenterSettings",
            name: "callCenterSettings",
            meta: {
                ...meta,
                title: "呼叫中心配置",
            },
            component: () => import("@/pages/business/callCenterSettings.vue"),
        },
        {
            path: "/business/seatSettings",
            name: "seatSettings",
            meta: {
                ...meta,
                title: "坐席配置",
            },
            component: () => import("@/pages/business/seatSettings.vue"),
        },
        {
            path: "/business/nationalHolidays",
            name: "nationalHolidays",
            meta: {
                ...meta,
                title: "节假日管理",
            },
            component: () => import("@/pages/business/nationalHolidays.vue"),
        },
        {
            path: "/business/regionManagement",
            name: "regionManagement",
            meta: {
                ...meta,
                title: "区域管理",
            },
            component: () => import("@/pages/business/regionManagement.vue"),
        },
        {
            path: "/business/recordingLog",
            name: "recordingLog",
            meta: {
                ...meta,
                title: "录音下载日志",
            },
            component: () => import("@/pages/business/recordingLog.vue"),
        },
        {
            path: "/business/dataReport",
            name: "dataReport",
            meta: {
                ...meta,
                title: "数据上报",
            },
            component: () => import("@/pages/business/dataReport/index.vue"),
        },
        {
            path: "/business/dataReportDetail",
            name: "dataReportDetail",
            meta: {
                ...meta,
                title: "数据上报详情",
            },
            component: () => import("@/pages/business/dataReport/detail.vue"),
        },
        {
            path: '/business/contactsList',
            name: 'contactsList',
            meta: {
              title: '通讯录'
            },
            component: () => import('@/pages/contactsManagement/index.vue')
          },
    ],
};
